// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mp-0";